/**
 * Authentication Constants
 *
 * Centralized constants for authentication-related timeouts, delays, and configuration values.
 * This file consolidates magic numbers and hardcoded values to improve maintainability
 * and make authentication behavior more configurable.
 */

/**
 * UI transition delay for smooth authentication flow animations
 * Used in CustomLoginPage to provide visual feedback during authentication initiation
 */
export const UI_TRANSITION_DELAY = 600; // milliseconds

/**
 * Retry delay for token refresh operations
 * Used in token management utilities when retrying failed token refresh attempts
 */
export const TOKEN_RETRY_DELAY = 1000; // milliseconds

/**
 * Token validity check intervals
 * Different values for development and production environments
 */
export const TOKEN_VALIDITY_SECONDS = {
  /** Development environment - shorter interval for faster testing */
  DEVELOPMENT: 30,
  /** Production environment - longer interval for better performance */
  PRODUCTION: 5,
} as const;

/**
 * Authentication flow state transition delays
 */
export const FLOW_DELAYS = {
  /** Delay before showing error messages to prevent flashing */
  ERROR_DISPLAY: 100, // milliseconds
  /** Delay for user info refresh after token update */
  USER_INFO_REFRESH: 100, // milliseconds
} as const;
